import { Component } from "@angular/core";
import {
  IonicPage,
  ToastController,
  PopoverController,
  Popover,
  ActionSheetController,
  ActionSheet,
  LoadingController,
} from "ionic-angular";
import { pouchdb2 } from "../../services/pouchdb/pouchdb.service";
import { APIOnLine } from "../../services/api/api.services";
import { NgForm } from "@angular/forms/src/directives/ng_form";
import { PaginaBasica } from "../../models/PaginaBase";
import { Proxy } from "../../services/proxy/proxy.service";
import { NuevoMenuDerechoComponent } from "../../components/nuevo-menu-derecho/nuevo-menu-derecho";

export interface iVentanasCambios {
  numeroVentana: number;
  maxCambios: number;
  cambios: Proxy.PrCambios[];
  activarFormulario: boolean;
  esDescanso: boolean;
  nuevoCambio: Proxy.PrCambios;
}

@IonicPage()
@Component({
  selector: "page-cambios",
  templateUrl: "cambios.html",
})
export class CambiosPage extends PaginaBasica {
  //#region Propiedades del controlador
  public designacion: Proxy.PrDesignaciones;
  public idEquipo: number;
  public licencias: Proxy.ListaPrPersonaAlineable;
  public participantes: Proxy.ListaPrParticipacion;
  public cambios: Proxy.ListaPrCambios;
  public cambio: Proxy.PrCambios;
  public ventanaDescanso: iVentanasCambios;
  public ventanas: iVentanasCambios[] = [];
  //#endregion

  constructor(
    public actionSheetCtrl: ActionSheetController,
    public CFutbolActas: APIOnLine.CFutbolActas,
    public DBService2: pouchdb2.DBService2,
    public loadingCtrl: LoadingController,
    public popOverCtrl: PopoverController,
    public Persistentes: APIOnLine.Persistentes,
    public toastCtrl: ToastController
  ) {
    super(loadingCtrl, toastCtrl);
  }

  ionViewDidLoad() {
    console.log("--- ENTRO EN LA PÁGINA: Cambios ---");
    this.designacion = this.Persistentes.GetDesignacion();
    this.idEquipo = this.Persistentes.GetIdEquipo();

    console.log("Datos de la designación", this.designacion);

    this.MostrarOcultarCarga(false, "cargando alineación");

    this.licencias = new Proxy.ListaPrPersonaAlineable(
      this.CFutbolActas,
      this.DBService2,
      this.Persistentes,
      this.designacion,
      this.idEquipo
    );
    this.participantes = new Proxy.ListaPrParticipacion(
      this.CFutbolActas,
      this.DBService2,
      this.Persistentes,
      this.toastCtrl,
      this.designacion,
      this.idEquipo
    );
    this.cambios = new Proxy.ListaPrCambios(
      this.CFutbolActas,
      this.DBService2,
      this.Persistentes,
      this.toastCtrl,
      this.designacion,
      this.idEquipo
    );

    this.participantes
      .CargarListaParticipacion()
      .then((resultado: boolean) => {
        return this.licencias.ObtenerAlineables(true, false, false);
      })
      .then((resultado: boolean) => {
        return this.cambios.CargarCambios();
      })
      .then((resultado: boolean) => {
        if (this.designacion.ventanasCambios) {
          this.InicializacionVentanas();
        }

        this.InicializarCambio();
        this.MostrarOcultarCarga();
      })
      .catch((error) =>
        this.Error(error, "ERROR al obtener la alineación de jugadores")
      );
  }

  //#region Métodos del controlador

  public AbrirMenuSecundario(event: any): void {
    let popover: Popover = this.popOverCtrl.create(NuevoMenuDerechoComponent);

    popover.present({
      ev: event,
    });
  }

  /**
   * Se elimina el cambio pasado como parámetro
   * @param cambio Datos del cambio a eliminar
   */
  public EliminarCambio(cambio: Proxy.PrCambios): void {
    let actionSheet: ActionSheet = this.actionSheetCtrl.create({
      title: "Eliminar cambio",
      subTitle: "¿Desea eliminar los datos del cambio que ha seleccionado?",
      buttons: [
        {
          text: "ELIMINAR",
          handler: () => {
            this.cambios.lista.forEach((valor: Proxy.PrCambios, i: number) => {
              if (valor.idCambio == cambio.idCambio) {
                cambio
                  .Eliminar()
                  .then((resultado: boolean) => {
                    this.cambios.lista.splice(i, 1);
                  })
                  .catch((error) =>
                    this.Error(error, "Eliminando cambio en la designación")
                  );
              }
            });
          },
        },
        {
          text: "Cancelar",
          role: "cancel",
        },
      ],
    });

    actionSheet.present();
  }

  /**
   * Inicializa los datos del cambio a introducir
   */
  public InicializarCambio(form: NgForm = undefined): void {
    this.cambio = new Proxy.PrCambios(
      this.CFutbolActas,
      this.DBService2,
      this.Persistentes
    );
    this.cambio.idDesignacion = this.designacion.idDesignacion;
    this.cambio.idEquipo = this.idEquipo;
    this.cambio.urlApi = this.designacion.urlApi;
    this.cambio.urlNombre = this.designacion.urlNombre;
    this.cambio.ventana = null;
    this.cambio.descanso = null;
    if (form != undefined) {
      form.reset();
    }
  }

  public Insertar(form: NgForm): void {
    if (form.valid) {
      if (
        this.cambios.CambioPosible(
          this.cambio.entra,
          this.cambio.sale,
          this.participantes
        )
      ) {
        this.cambio
          .Guardar()
          .then((resultado: Proxy.PrCambios) => {
            this.cambios.lista.push(resultado);
            this.InicializarCambio(form);
          })
          .catch((error) =>
            this.Error(
              error,
              "ERROR en la operación de guardado del cambio actual"
            )
          );
      } else {
        this.Mensaje("No se puede realizar el cambio que ha indicado.", 6000);
      }
    }
  }

  //#endregion

  // #region Métodos relacionados con las ventanas de cambios

  /**
   * Activa el formulario relacionado con la ventana indicada.
   * @param ventana Datos de la ventana
   */
  ActivarFormularioVentana(ventana: iVentanasCambios): void {
    // Reinicio del valor de la activación del formulario en todas las ventanas
    this.ventanaDescanso.activarFormulario = false;
    this.ventanas.forEach((datos: iVentanasCambios) => {
      datos.activarFormulario = false;
    });

    if (ventana.esDescanso) {
      ventana.activarFormulario = true;
      this.ventanaDescanso = ventana;

      // Inicialización de los datos del nuevo cambio.
      this.InicializarCambioEnVentana(ventana);
    } else {
      this.ventanas.forEach((datos: iVentanasCambios) => {
        if (ventana.numeroVentana == datos.numeroVentana) {
          datos.activarFormulario = true;
          this.InicializarCambioEnVentana(datos);
        }
      });
    }
  }

  /**
   * Comprueba si es posible añadir un nuevo cambio en la ventana correspondiente.
   *
   * Además de mirar si el número de cambios en la ventana ya se ha cumplido, mira también que no se hayan establecido ya todos los cambios.
   * @param ventana Datos de la ventana.
   */
  CambiosEstablecidos(ventana: iVentanasCambios): boolean {
    return this.CambiosRealizados() < this.designacion.numeroMaxCambios &&
      ventana.cambios.length < ventana.maxCambios
      ? false
      : true;
  }

  /**
   * Elimina un cambio de una ventana.
   * @param cambio Datos del cambio a eliminar
   * @param ventana Datos de la ventana donde está el cambio.
   */
  EliminarCambioEnVentana(
    cambio: Proxy.PrCambios,
    ventana: iVentanasCambios
  ): void {
    let actionSheet: ActionSheet = this.actionSheetCtrl.create({
      title: "Eliminar cambio",
      subTitle: "¿Desea eliminar los datos del cambio que ha seleccionado?",
      buttons: [
        {
          text: "ELIMINAR",
          handler: () => {
            cambio
              .Eliminar()
              .then((resultado: boolean) => {
                ventana.cambios = ventana.cambios.filter(
                  (m) => m.idCambio != cambio.idCambio
                );

                // Actualización en la lista de las ventanas
                if (ventana.esDescanso) {
                  this.ventanaDescanso = ventana;
                } else {
                  this.ventanas.forEach((valor: iVentanasCambios) => {
                    if (valor.numeroVentana == ventana.numeroVentana) {
                      valor = ventana;
                    }
                  });
                }
              })
              .catch((error) =>
                this.Error(error, "Eliminando cambio en la designación")
              );
          },
        },
        {
          text: "Cancelar",
          role: "cancel",
        },
      ],
    });

    actionSheet.present();
  }

  /**
   * Inicializa los datos del cambio a introducir en una ventana.
   * @param   ventana   Ventana en la que se va a incluir el cambio.
   */
  InicializarCambioEnVentana(
    ventana: iVentanasCambios,
    desactivarFormulario: boolean = false
  ): void {
    let cambio: Proxy.PrCambios = new Proxy.PrCambios(
      this.CFutbolActas,
      this.DBService2,
      this.Persistentes
    );
    cambio.idDesignacion = this.designacion.idDesignacion;
    cambio.idEquipo = this.idEquipo;
    cambio.urlApi = this.designacion.urlApi;
    cambio.urlNombre = this.designacion.urlNombre;
    cambio.entra = undefined;
    cambio.minuto =
      ventana.cambios != null && ventana.cambios.length > 0
        ? ventana.cambios[0].minuto
        : "";
    cambio.sale = undefined;
    cambio.ventana = ventana.numeroVentana;
    cambio.descanso = ventana.esDescanso;
    cambio.idCambio = 0;
    cambio.minutoExtra = ventana.cambios != null && ventana.cambios.length > 0 
      ? ventana.cambios[0].minutoExtra 
      : "";

    ventana.nuevoCambio = cambio;

    if (desactivarFormulario) {
      ventana.activarFormulario = false;
    }
  }

  InsertarEnVentana(form: NgForm, ventana: iVentanasCambios): void {
    if (form.valid) {
      if (
        this.cambios.CambioPosible(
          ventana.nuevoCambio.entra,
          ventana.nuevoCambio.sale,
          this.participantes
        )
      ) {
        // Guardado del cambio en la ventana de carga
        ventana.nuevoCambio
          .Guardar()
          .then((resultado: Proxy.PrCambios) => {
            ventana.cambios.push(resultado);

            // Desactivación del formulario de nuevo cambio
            ventana.activarFormulario = false;
            ventana.nuevoCambio = null;

            // Actualización en la lista de las ventanas
            if (ventana.esDescanso) {
              this.ventanaDescanso = ventana;
            } else {
              this.ventanas.forEach((valor: iVentanasCambios) => {
                if (valor.numeroVentana == ventana.numeroVentana) {
                  valor = ventana;
                }
              });
            }
          })
          .catch((error) =>
            this.Error(
              error,
              "ERROR en la operación de guardado del cambio actual."
            )
          );
      } else {
        this.Mensaje("No se puede realizar el cambio que ha indicado.", 6000);
      }
    }
  }

  /**
   * Indica si ya se ha establecido el minuto en la ventana (hay al menos un cambio)
   * @param ventana Datos de la ventanta
   * @returns Booleano
   */
  MinutoEstablecido(ventana: iVentanasCambios): boolean {
    return ventana.cambios != null && ventana.cambios.length > 0;
  }

  /**
   * Indica si se debe mostrar la ventana de cambio, según los cambios realizados en otras ventanas.
   *
   * Solamente se debe mostrar la ventana, si no se han completado los cambios en la ventana anterior y no se ha llegado al total de cambios
   * @param numeroVentana Indica el número de ventana de cambio
   */
  MostrarVentanaCambio(numeroVentana: number): boolean {
    let resultado: boolean = false;
    let tieneCambios: boolean =
      this.ventanas[numeroVentana - 1].cambios.length > 0;

    if (tieneCambios) {
      resultado = true;
    } else if (this.CambiosRealizados() < this.designacion.numeroMaxCambios) {
      if (numeroVentana == 1) {
        resultado = true;
      } else {
        // Todas las ventanas anteriores deben tener al menos un cambio
        let anteriores: boolean = true;

        for (let i: number = 1; i < numeroVentana; i++) {
          if (this.ventanas[i - 1].cambios.length == 0) {
            anteriores = false;
          }
        }

        resultado = anteriores;
      }
    }

    return resultado;
  }

  /**
   * Obtiene el número de cambios realizados.
   * @returns Número de cambios realizados
   */
  private CambiosRealizados(): number {
    let cambiosRealizados: number = 0;

    if (this.ventanaDescanso.cambios.length > 0) {
      cambiosRealizados = this.ventanaDescanso.cambios.length;
    }
    this.ventanas.forEach((valor: iVentanasCambios) => {
      if (valor.cambios.length > 0) {
        cambiosRealizados += valor.cambios.length;
      }
    });

    return cambiosRealizados;
  }

  /**
   * Inicialización de las ventanas de cambios.
   */
  private InicializacionVentanas(): void {
    this.ventanaDescanso = {
      cambios: [],
      maxCambios: this.designacion.numeroMaxCambios, // En la ventana del descanso, se pueden realizar el total de cambios.
      numeroVentana: 0,
      activarFormulario: false,
      esDescanso: true,
      nuevoCambio: null,
    };

    for (let i = 0; i < this.designacion.numeroVentanas; i++) {
      this.ventanas.push({
        cambios: [],
        maxCambios: this.designacion.numeroMaxCambiosPorVentana,
        numeroVentana: i + 1,
        activarFormulario: false,
        esDescanso: false,
        nuevoCambio: null,
      });
    }


    // Inicialización de los cambios en cada ventantana
    if (
      this.cambios != null &&
      this.cambios.lista != null &&
      this.cambios.lista.length > 0
    ) {
      let cambiosMalIndicados: boolean = false;

      this.cambios.lista.forEach((cambio: Proxy.PrCambios) => {
        if (cambio.descanso == true) {
          this.ventanaDescanso.cambios.push(cambio);
        } else if (cambio.ventana != null) {
          this.ventanas[cambio.ventana - 1].cambios.push(cambio);
        } else {
          // En el caso de que no se haya establecido la ventana, se añade al descanso
          cambio.descanso = true;
          this.ventanaDescanso.cambios.push(cambio);
          cambiosMalIndicados = true;
        }
      });

      // En el caso de que existan cambios mal indicados, se muestra un mensaje de error
      if (cambiosMalIndicados) {
        this.Mensaje('Existen cambios mal indicados. Por favor, revise los datos de los cambios. Elimine los cambios que no correspondan.', 6000);
      }
    }

    console.log("Ventanas", this.ventanas);
  }

  // #endregion
}



// WEBPACK FOOTER //
// ./src/pages/cambios/cambios.ts